import { SunOutlined, MoonOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";

function ThemeSetting() {
  const [darkTheme, setDarkTheme] = useState(false);

  useEffect(() => {
    const localTheme = localStorage.getItem("dark_theme");
    if (localTheme === "dark") {
      setDarkTheme(true);
    } else {
      setDarkTheme(false);
    }
  }, []);

  const handleThemeChange = () => {
    if (darkTheme) {
      localStorage.setItem("dark_theme", "light");
      setDarkTheme(false);
    } else {
      localStorage.setItem("dark_theme", "dark");
      setDarkTheme(true);
    }

    window.location.reload();
  };

  return (
    <div style={{ cursor: "pointer" }}>
      {darkTheme ? (
        <span onClick={handleThemeChange}>
        <SunOutlined  style={{marginLeft:"10px",fontSize:"16px",fontWeight:"600",color:"gray"}}  />
       <span style={{fontSize:"16px",color:"gray",fontWeight:"600",marginLeft:"5px"}}> Light Mode</span> 
        </span>
      ) : (
        <span onClick={handleThemeChange}>
        <MoonOutlined  style={{marginLeft:"10px",fontSize:"16px",fontWeight:"600",color:"gray"}}  />
        <span style={{fontSize:"16px",color:"gray",fontWeight:"600",marginLeft:"5px"}}> Dark Mode</span> 
        </span>
      )}
    </div>
  );
}

export default ThemeSetting;